import { IconButton, Text,Box, Stack } from "@chakra-ui/react";
import { FiChevronLeft,FiChevronsLeft, FiChevronRight, FiChevronsRight } from "react-icons/fi";
import { useState} from "react";
import { numOfPages } from "../../util/grunt";


const GruntPager = ({currpage=1,rowcount, rowsperpage, onClick, buttonsize='xs'}) => {
    
    

    const [currentpage,setCurrentPage]=useState(currpage);
    
    
    const SetPage=(move)=>{
        let _num=currentpage;
        
        switch (move) {
            case "first":
                _num=1;
                break;
            case "previous":
                _num=_num-1;
                break;
            case "next":
                _num=_num+1;
                break;
            default:
                _num=numOfPages(rowcount,rowsperpage);
        }
        if (_num<1) {
            _num=1;
        }
        if (_num>numOfPages(rowcount,rowsperpage)) {
            _num=numOfPages(rowcount,rowsperpage);
        }
        setCurrentPage(_num);
        onClick(_num);
        
    }
    return (
        
                <Box display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                <Stack direction={'row'} alignItems={'center'}>
                
                <IconButton onClick={(e)=>SetPage('first')}  size={buttonsize} variant='outline' colorScheme='grunt2' icon={<FiChevronsLeft />} />
                <IconButton onClick={(e)=>SetPage('previous')}  size={buttonsize} variant='outline' colorScheme='grunt2' icon={<FiChevronLeft />} />
                    <Text fontSize={buttonsize} fontWeight={'semibold'}>
                    {currpage} / {numOfPages(rowcount,rowsperpage)}
                    </Text>
                <IconButton onClick={(e)=>SetPage('next')}  size={buttonsize} variant='outline' colorScheme='grunt2' icon={<FiChevronRight />} />
                <IconButton onClick={(e)=>SetPage('last')}  size={buttonsize} variant='outline' colorScheme='grunt2' icon={<FiChevronsRight />} />
                </Stack>
                
                </Box>
            
    );
}

export default GruntPager;
